import DataTransferObject from '@/Communication/DataTransferObject';
import ComponentManager from '@/Management/ComponentManager';
import UserGroupDTO from '@/Communication/UserGroupDTO';
import PrincipalRoleDTO from '@/Communication/PrincipalRoleDTO';

export default class PrincipalsAndUserGroupsDTO extends DataTransferObject {

    public Principals: Array<PrincipalRoleDTO>;

    public UserGroups: Array<UserGroupDTO>;

    constructor() {
        super({ xmlProperties: ['Principals', 'UserGroups'], xmlNamespace: 'RADFoundation.RoleAssignment' });

        this.Principals = this.defaultFromType('array');
        this.UserGroups = this.defaultFromType('array');
    }
}

ComponentManager.setModel('PrincipalsAndUserGroupsDTO', PrincipalsAndUserGroupsDTO, 'RADPresentation.HTMLClient.DefaultViewExtensions');